// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "practitioner".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
import { appointmentColorValues, countryCodeValues, employmentTypeValues } from '@borradh-workspace/labels';
/** Response atom for the "practitioner" table (1:1 with a DB row, on the wire). */
export const practitionerAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    userId: z.string().nullable(),
    name: z.string(),
    firstName: z.string().nullable(),
    lastName: z.string().nullable(),
    email: z.string(),
    phone: z.string().nullable(),
    phoneSecondary: z.string().nullable(),
    phoneCountry: z.string().nullable(),
    country: z.enum(countryCodeValues).nullable(),
    photo: z.string().nullable(),
    bio: z.string().nullable(),
    title: z.string().nullable(),
    headline: z.string().nullable(),
    dateOfBirth: z.string().nullable(),
    employmentStartDate: z.string().nullable(),
    employmentEndDate: z.string().nullable(),
    employmentType: z.enum(employmentTypeValues).nullable(),
    teamMemberRef: z.string().nullable(),
    notes: z.string().nullable(),
    acceptsBookings: z.boolean(),
    languages: z.array(z.string()).nullable(),
    socialLinks: z.unknown().nullable(),
    isActive: z.boolean(),
    profileSetupCompleted: z.boolean(),
    calendarAccountId: z.string().nullable(),
    bookingAccountId: z.string().nullable(),
    externalBookingId: z.string().nullable(),
    bookingLink: z.string().nullable(),
    workingHours: z.unknown().nullable(),
    color: z.enum(appointmentColorValues).nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
    deletedAt: z.string().datetime().nullable(),
});
//# sourceMappingURL=practitioner.js.map